import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

import { useCart } from '../contexts/CartContext';

export default function PwaCartBanner() {
  const navigate = useNavigate();
  const { getItemCount } = useCart();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem('pwa_cart_banner_dismissed') === '1';
    setDismissed(stored);
  }, []);

  const count = getItemCount();
  if (count <= 0 || dismissed) return null;

  return (
    <div className="pwa-only pwa-cart-banner">
      <div className="pwa-cart-banner__inner">
        <div className="pwa-cart-banner__info">
          <ShoppingCart className="w-4 h-4" />
          <span>You have {count} item{count > 1 ? 's' : ''} in cart</span>
        </div>
        <div className="pwa-cart-banner__actions">
          <button
            className="pwa-cart-banner__btn"
            type="button"
            onClick={() => navigate('/checkout')}
          >
            Checkout
          </button>
          <button
            className="pwa-cart-banner__link"
            type="button"
            onClick={() => {
              sessionStorage.setItem('pwa_cart_banner_dismissed', '1');
              setDismissed(true);
            }}
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
